var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampjsalarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1644)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_158_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 1.73327C6.56802 1.73327 1.354 6.94728 1.354 13.3791C1.354 19.8109 6.56802 25.0249 12.9998 25.0249C19.4317 25.0249 24.6457 19.8109 24.6457 13.3791C24.6457 6.94728 19.4317 1.73327 12.9998 1.73327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46573 2.09689C6.81613 1.81657 6.87295 1.30527 6.59263 0.954868C6.31231 0.604467 5.80101 0.547656 5.4506 0.827976L2.74227 2.99464C2.39187 3.27496 2.33506 3.78626 2.61538 4.13666C2.8957 4.48706 3.407 4.54388 3.7574 4.26356L6.46573 2.09689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5491 0.827976C20.1987 0.547656 19.6874 0.604467 19.407 0.954868C19.1267 1.30527 19.1835 1.81657 19.5339 2.09689L22.2423 4.26356C22.5927 4.54388 23.104 4.48706 23.3843 4.13666C23.6646 3.78626 23.6078 3.27496 23.2574 2.99464L20.5491 0.827976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22495 4.44901L2.59241 4.15504L2.22495 4.44901C2.67777 5.01504 3.50372 5.10681 4.06975 4.65399L6.77808 2.48732C7.34411 2.0345 7.43589 1.20855 6.98306 0.64252C6.53024 0.0764886 5.70429 -0.0152829 5.13826 0.437542L5.4506 0.827976L5.13826 0.437542L2.42992 2.60421C1.86389 3.05703 1.77212 3.88298 2.22495 4.44901ZM12.9998 1.23327C6.29188 1.23327 0.854004 6.67114 0.854004 13.3791C0.854004 20.0871 6.29188 25.5249 12.9998 25.5249C19.7078 25.5249 25.1457 20.0871 25.1457 13.3791C25.1457 6.67114 19.7078 1.23327 12.9998 1.23327ZM20.8614 0.437542C20.2954 -0.0152829 19.4694 0.0764884 19.0166 0.64252V0.64252C18.5638 1.20855 18.6556 2.0345 19.2216 2.48732L21.9299 4.65399C22.496 5.10681 23.3219 5.01504 23.7747 4.44901C24.2275 3.88298 24.1358 3.05703 23.5697 2.60421L20.8614 0.437542Z",
    stroke: "url(#paint0_linear_158_1644)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_158_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8122 9.0459C13.8122 8.59717 13.4484 8.2334 12.9997 8.2334C12.551 8.2334 12.1872 8.59717 12.1872 9.0459V13.6022C12.1872 13.9476 12.0552 14.2799 11.8183 14.5312L10.2418 16.2033C9.934 16.5298 9.94914 17.044 10.2756 17.3518C10.6021 17.6597 11.1164 17.6445 11.4242 17.318L13.0007 15.6459C13.5219 15.0931 13.8122 14.362 13.8122 13.6022V9.0459Z",
    fill: "#001F55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_158_1644",
    x: -23.646,
    y: -24.3501,
    width: 73.2915,
    height: 74.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_158_1644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_158_1644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_1644",
    x: 7.02051,
    y: 5.2334,
    width: 19.7915,
    height: 25.3398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_1644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_1644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_1644",
    x1: 1.354,
    y1: 0.649902,
    x2: 25.7151,
    y2: 23.9046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsalarm);
export default __webpack_public_path__ + "static/media/Bootcamp js alarm.fa1c3c777ed63093699ee5eaacea4109.svg";
export { ForwardRef as ReactComponent };